import { Col, List, Row } from 'antd';
import { useState } from 'react';

import { Schemas } from '@api-client/generated/types';
import { IconLegal, IconPerson } from '@assets';
import { PersonType } from '@entities/onboarding/types';

import { CompanyCard } from '../cards/CompanyCard/CompanyCard';
import { PersonCard } from '../cards/PersonCard/PersonCard';
import { getDetailsByCompanyRelations } from '../helpers';
import * as S from '../styled';

type Person = Schemas.PersonResponseDto;

type CompanyOwnersProps = {
  companyId: string;
  persons: Person[];
  isLoading: boolean;
};

/**
 * The people behind the company, read-only. Nothing here writes any more — the KYC form, the
 * KYC-link mint and the UBO-number assignment are all gone — so there is no refetch to trigger
 * either.
 */
export const CompanyOwners = (props: CompanyOwnersProps) => {
  const [selectedPersonIndex, setSelectedPersonIndex] = useState<number>(-1);

  const persons = props.persons.filter(
    (person) => person.id !== props.companyId
  );

  const selectedPerson = persons[selectedPersonIndex];

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={8}>
          <S.PersonsWrapper>
            <List
              itemLayout="horizontal"
              dataSource={persons}
              loading={props.isLoading}
              renderItem={(person, index) => (
                <S.PersonItem
                  isSelected={selectedPerson?.id === person.id}
                  onClick={() => setSelectedPersonIndex(index)}
                >
                  <List.Item.Meta
                    avatar={
                      person.type === 'legal' ? (
                        <IconLegal />
                      ) : (
                        <IconPerson width={24} height={24} />
                      )
                    }
                    title={person.name}
                    description={getDetailsByCompanyRelations(
                      person.companyRelations
                    )}
                  />
                </S.PersonItem>
              )}
            />
          </S.PersonsWrapper>
        </Col>

        <Col span={16}>
          {selectedPerson &&
            (selectedPerson?.type === PersonType.Legal ? (
              <CompanyCard company={selectedPerson} />
            ) : (
              <PersonCard person={selectedPerson} />
            ))}
        </Col>
      </Row>
    </>
  );
};
